module.exports = __webpack_public_path__ + "static/media/bent-nose-thumb.c33decbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Reconstructions/2D/bent-nose-thumb.jpg
// module id = 472
// module chunks = 0